import React from 'react';
import classnames from 'classnames';

import styles from './EmptyFeed.module.scss';

interface EmptyFeedProps {
  /** @string - Classname to be passed to the wrapper div */
  className?: string;
  /** @string - Empty feed text message */
  message?: string;
}

const EmptyFeed: React.FC<EmptyFeedProps> = ({ className, message }) => {
  return <div className={classnames(className, styles.container)}>{message}</div>;
};

export default EmptyFeed;
